import React from 'react';
import {
  StapleTable,
  StapleTableBody,
  StapleTableHeader,
  StapleTableHeading,
  StapleTableRow,
} from '@insurancemenu/imenu-components-lib';
import { ReplicatedCustomInfo } from 'types/formService';
import InfoCardTableRow from './InfoCardTableRow';

export interface ReplicatedInfoTableColumn {
  title: string;
  width?: string;
  getValue: (item: ReplicatedCustomInfo) => string;
}

interface Props {
  items: ReplicatedCustomInfo[];
  columns: ReplicatedInfoTableColumn[];
  onEditItem: (item: ReplicatedCustomInfo) => void;
  onDeleteItem: (id: string) => void;
}

const InfoCardsTable: React.FC<Props> = ({ items, columns, onEditItem, onDeleteItem }) => {
  return (
    <StapleTable totalElements={items.length} minHeight="20rem" maxHeight="none">
      <StapleTableHeader>
        <StapleTableRow>
          {columns.map((col, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <StapleTableHeading key={`column-${index}`} width={col.width}>
              {col.title}
            </StapleTableHeading>
          ))}
          <StapleTableHeading width="6rem" />
        </StapleTableRow>
      </StapleTableHeader>
      <StapleTableBody>
        {items.map((item) => (
          <InfoCardTableRow
            key={`row-${item.id}`}
            item={item}
            columns={columns}
            onEdit={onEditItem}
            onDelete={onDeleteItem}
          />
        ))}
      </StapleTableBody>
    </StapleTable>
  );
};

export default InfoCardsTable;
